import { BASE_API_URL } from "../../config/Api";
import { CREATE_POST, POST_DATA, POST_DETAILS, REMOVE_POST_DATA } from "./ActionType";

export const createPost=(formData,token)=>async(dispatch)=>{
    try {

        const res=await fetch(`${BASE_API_URL}/createPost`,{
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
              },
             body: formData,
        })
        const resData=await res.json();
        if (resData.statusCode === "00") {
            dispatch({type:CREATE_POST, payload:resData})
            return { success: true };
          } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
         }
    } catch (error) {
        
    }
}

export const getSocialPostDetails=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/getSocialPost?hrmsSocialPostId=0`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
        })
        const resData=await res.json();
        if (resData.statusCode === "00") {
            dispatch({type:POST_DETAILS, payload:resData})
            return { success: true };
          } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
         }
    } catch (error) {
        
    }
}

export const getSocialPostData=(postId,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/getSocialPost?hrmsSocialPostId=${postId}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
        })
        const resData=await res.json();
        if (resData.statusCode === "00") {
            dispatch({type:POST_DATA, payload:resData})
            return resData;
          } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
         }
    } catch (error) {
        
    }
}

export const removeSocialPostData=(postId,token)=>async(dispatch)=>{
  try {
      const res=await fetch(`${BASE_API_URL}/removeSocialPost?hrmsSocialPostId=${postId}`,{
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
      })
      const resData=await res.json();
      if (resData.statusCode === "00") {
          dispatch({type:REMOVE_POST_DATA, payload:resData})
          return { success: true };
        } else {
          throw new Error(resData.statusDesc || 'Unknown error occurred');
       }
  } catch (error) {
      
  }
}